/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Ivory_Goose_TiltInputs */

const en_fair_ivory_goose_tilt = /** @type {(inputs: Fair_Ivory_Goose_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer feedback templates will be replaced if they already exist.`)
};

const de_fair_ivory_goose_tilt = /** @type {(inputs: Fair_Ivory_Goose_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen für Peer-Feedback werden ersetzt, wenn sie bereits existieren.`)
};

/**
* | output |
* | --- |
* | "Peer feedback templates will be replaced if they already exist." |
*
* @param {Fair_Ivory_Goose_TiltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_ivory_goose_tilt = /** @type {((inputs?: Fair_Ivory_Goose_TiltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Ivory_Goose_TiltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_ivory_goose_tilt(inputs)
	return de_fair_ivory_goose_tilt(inputs)
});